import { SearchSpotIllustration } from '@y2/mango/components/illustrations/spot';
import texts from './no-results.text.json';
import styles from './no-results.module.scss';

export function NoResults() {
  return (
    <div className={styles.box}>
      <SearchSpotIllustration />
      <h3 className={styles.title}>{texts.message}</h3>
    </div>
  );
}
